import React, { useState, useEffect } from "react";
import productos from "../../hooks/productos.json";
import menu from "../../hooks/menu.json";
import './Listado.css';
import { useLocation, Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";

const ProductosListado = () => {

    const [data, setData] = useState({});
    const { pathname } = useLocation();
    const [productosData, setProductosData] = useState([]);
    const [meta, setMeta] = useState({});


    const findMenuById = (m, id) => {
        for (let i = 0; i < m.length; i++) {
            if (m[i].id === id) {
                return m[i];
            }
            if (m[i].items) {
                let item = findMenuById(m[i].items, id);
                if (item) return item;
            }
        }

    }

    const loadProductsByItems = (item) => {

        if (!item) return;
        if (item.items) {
            for (let i = 0; i < item.items.length; i++) {
                loadProductsByItems(item.items[i]);
            }
        } else {
            let products = productos.filter(p => p.id === item.id);
            if (products.length > 0 && products[0].gallery) {
                productosData.push(products[0]);
                setProductosData(productosData);
            }
        }

    }

    const loadData = () => {

        let id = pathname.split('/').pop();
        productosData.length = 0;
        setProductosData([]);
        let item = findMenuById(menu, id);
        console.log(item);
        setMeta({
            title: item.name || 'Productos',
            description: item.content || 'Productos',
            canonical: 'https://' + window.location.host + pathname,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: `productos, listado, ${item.name}, ${item.content}`
                }
            }
        });
        setData(item);
        loadProductsByItems(item);

    }

    const groupByType = (productos) => {
            return productos.reduce((acc, producto) => {
                const tipo = producto.type || 'Otros';
                if (!acc[tipo]) {
                    acc[tipo] = [];
                }
                acc[tipo].push(producto);
                return acc;
            }, {});
        };
        
    useEffect(() => {
        loadData();
    }, [pathname]);

    return (
        <DocumentMeta {...meta}>
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1>{data.name || 'Productos'}</h1>
                        <p className="text-info">{data.type || ''}</p>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
                </div>
            </div>
            <div className="project-single-area ptb-100">
                <section id="projects" className="projects-section-three">
                    <div className="container">
                        {Object.entries(groupByType(productosData)).map(([tipo, productos]) => (
                            <div key={tipo} className="mb-5">
                                {data.id === "productos" && (
                                    <h2 className="mb-4 tipo-producto">{tipo}</h2>
                                )}
                                <div className="row filter-container text-center">
                                    {productos.map((producto) => (
                                        <div className="filter-item col-lg-4 col-md-6" key={producto.id}>
                                            <div className="item-single mb-30">
                                                <div className="image">
                                                    <img src={process.env.PUBLIC_URL + "/assets/img/productos/" + producto.gallery[0].image} alt={producto.title} />
                                                </div>
                                                <h4><Link to={'/productos/' + producto.id} className="text-info">{producto.title}</Link></h4>
                                                <div className="content">
                                                    <div className="p-3">
                                                        <h3><Link to={'/productos/' + producto.id} className="">{producto.title}</Link></h3>
                                                        <p className="text-white mb-5">{producto.subTitle}</p>
                                                        <Link to={'/productos/' + data.id + '/' + producto.id} className="project-btn">Detalles</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>

        </DocumentMeta>

    );
}

export default ProductosListado;